export default "__VITE_ASSET__BiGgsegj__"